(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    var hash = $(location).prop('hash');
    if(hash !== ""){
      var button = hash + ">button";
      $(button).trigger("click");
      //リンク先を取得
      const target = $(hash),
      //リンク先までの距離を取得
      position = target.offset().top - 120;
      //指定の場所までスムーススクロール
      $('html,body').scrollTop(position);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-faq"] && !Shopify.designMode) return;
  try {
    
  $(function () {
    var hash = $(location).prop('hash');
    if (hash !== "") {
      var button = hash + ">button";
      $(button).trigger("click");

      const target = $(hash),
        position = target.offset().top - 120;

      $('html,body').scrollTop(position);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-list-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var swiperBox = document.querySelector("#section-news-list-slide .swiperBox");
    if (!swiperBox) return;

    var articleCount = parseInt(swiperBox.getAttribute('data-article-count')) || 0;
    var postLimit = parseInt(swiperBox.getAttribute('data-post-limit')) || 3;
    var shouldUseSlider = articleCount > postLimit;

    if (shouldUseSlider) {
      new Swiper("#section-news-list-slide .swiperNewsList", {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: postLimit,
            spaceBetween: 24
          }
        },
        pagination: {
          el: "#section-news-list-slide .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: "#section-news-list-slide .swiper-button-next",
          prevEl: "#section-news-list-slide .swiper-button-prev"
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-list"] && !Shopify.designMode) return;
  try {
    
$(window).scroll(function() {
  sessionStorage.scrollTop = $(this).scrollTop();
});

$(document).ready(function() {
  if(location.search != ""){
    if (sessionStorage.scrollTop != "undefined") {
      $(window).scrollTop(sessionStorage.scrollTop);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-popup"] && !Shopify.designMode) return;
  try {
    
  // #popupTargetが存在するかチェック
  const popupTarget = document.querySelector('#popupTarget');
  const productPopup = document.getElementById('productPopup');
  
  if (popupTarget) {
    // 商品詳細ページ: ターゲット要素が表示されたら表示、上に戻ったら非表示
    window.addEventListener('scroll', function () {
      // ターゲットの画面トップからの距離
      const targetPosition = popupTarget.getBoundingClientRect().top;
      
      if (productPopup) {
        // 画面トップからの距離から画面の高さより小さければ表示
        if (targetPosition <= window.innerHeight) {
          productPopup.classList.add("fadeIn");
          productPopup.classList.remove("fadeOut");
        } else {
          // 上に戻ったら非表示
          productPopup.classList.remove("fadeIn");
          productPopup.classList.add("fadeOut");
        }
      }
    });
  } else {
    // その他のページ（フッターなど）: 100pxスクロールしたら表示、上に戻ったら非表示
    window.addEventListener('scroll', function () {
      if (productPopup) {
        if (window.scrollY >= 100) {
          productPopup.classList.add("fadeIn");
          productPopup.classList.remove("fadeOut");
        } else {
          // 上に戻ったら非表示
          productPopup.classList.remove("fadeIn");
          productPopup.classList.add("fadeOut");
        }
      }
    });
  }

  let swiperPopup = new Swiper('.swiperPopup', {

    // オプション設定
    navigation: {
      nextEl: '.popupProductArea .swiper-button-next',
      prevEl: '.popupProductArea .swiper-button-prev',
    },
  
    speed: 500,
    effect: 'slide',
    slidesPerView: 3.2, // 画像の表示枚数
    spaceBetween: 20, // 画像間の余白（px）
  });

  } catch(e) { console.error(e); }
})();
})();
